<template>
  <div class="page-container">
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <!-- 首页 -->
      <el-tab-pane name="home" stretch>
        <el-image slot="label"
          style="width: 100px; height: 16px"
          :src='img_icon'
          fit="contain"></el-image>
        <TeHome></TeHome>
      </el-tab-pane>

      <el-tab-pane label="星球产品" name="products">
        <TeProducts></TeProducts>
      </el-tab-pane>

      <!-- <el-tab-pane label="用户协议" name="about">
        <TeAbout></TeAbout>
      </el-tab-pane> -->

      <el-tab-pane label="联系Testars" name="contact">
        <TeContact></TeContact>
      </el-tab-pane>
    </el-tabs>

    <!-- 页面底部 -->
    <div style="position: relative; margin: 0 auto; width: 80vw;">
      <el-divider></el-divider>
    </div>
    <!-- 简介 -->
    <div class="bottom_info_area">
      <div class="sologon_area">
        <span class="info_title">Copyright © 2023 Testars特星球. 保留所有权利。</span>
        <span class="info_title">深圳市纽百特信息科技有限公司</span>
        <a class="info_title info_title_a" href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2022058473号-1</a>
        <a class="info_title info_title_a" href="/caluse" target="_blank">用户协议</a>
      </div>
      <!-- <div class="info_area">
        <span class="info_title">深圳市纽百特信息科技有限公司</span>
        <a class="info_title info_title_a" href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2022058473号-1</a>
        <span class="info_title">联系我们：</span>
        <span class="info_title">邮箱：191389703@qq.com</span>
        <span class="info_title">微信：HarryLee_39</span>
      </div> -->
    </div>
  </div>
</template>

<script>
import img_icon from "@/assets/icon.png";
import TeHome from "./TeHome";
import TeAbout from "./TeAbout";
import TeContact from "./TeContact";
import TeProducts from "./TeProducts";
import clause from "../clause/index";

export default {
  name: 'home',
  components: {
  },
  data() {
    return {
      img_icon,
      activeTab: "home",
    }
  },
  components: {
    TeHome,
    TeProducts,
    TeAbout,
    TeContact,
    clause
  },
  mounted() {

  },
  methods: {
    handleTabClick (options) {

    },
  },
}
</script>

<style>
.bottom_info_area {
  width: 100vw;
  background-color: rgba(0, 0, 0, 0);
  display: flex;
  justify-content: flex-start;
  /* flex-direction: column; */
  align-items: center;
  margin-bottom: 40px;
}

.sologon_area {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
}

.sologon_title {
  font-size: 12px;
  color: #424245;
}

.sologon_sub_title{
  font-size: 12px;
  color: #424245;
}

.info_area {
  width: 100%;
  height: 100%;
  /* background-color: orange; */
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}


.info_title {
  font-size: 12px;
  color: #424245;
  text-align: left;
  text-align: left;
  line-height: 18px;
  /* background-color: red; */
}
.info_title_a {
  text-decoration: none!important;
  color: #424245!important;
}
/* .info_title_a {
  text-decoration: #424245!important;
} */
</style>
